<script setup>
import {computed, onMounted, ref} from 'vue';

const props = defineProps({
  modelValue: null,
  padding: {
    type: String,
    default: 'p-2.5'
  }
});

const emit = defineEmits(['update:modelValue', 'change']);

const input = ref(null);

onMounted(() => {
  if (input.value.hasAttribute('autofocus')) {
    input.value.focus();
  }
});

defineExpose({focus: () => input.value.focus()});

const model = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const showingPlaceholder = computed(() =>
  props.modelValue === null || props.modelValue === undefined || props.modelValue === ''
);
</script>

<template>
  <select ref="input"
          class="shadow-sm bg-white border border-gray-300 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full disabled:bg-white disabled:border-gray-200 disabled:text-gray-500"
          :class="[padding, showingPlaceholder ? 'text-gray-500' : 'text-gray-900']"
          v-model="model"
          @change="(event) => emit('change', event)"
  >
    <slot/>
  </select>
</template>

<style scoped>
select option {
  color: #111827;
}
</style>
